import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import Select, { Option } from './Select'
import { TIME_RANGES } from '../../utils/timeRange'

// fixed width since the "Time Range" label alone is too narrow for the options
const TimeRangeSelect = ({ value, onChange, className }) => (
  <Select
    className={cx('w5-ns', className)}
    label="Time Range"
    input={{ value, onChange }}
  >
    {TIME_RANGES.map(x => (
      <Option value={x.value} key={x.value}>
        {x.label}
      </Option>
    ))}
  </Select>
)

TimeRangeSelect.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
}

export default TimeRangeSelect
